import type {
  PoolPageTypeName,
  PoolInfo,
  UpdatePoolPageTypeNameRequest,
} from '@/types/poolPageTypeName.types';
import { ApiClient } from '@/config/axios.config';

export class PoolPageTypeNameService {
  static async getPoolPageTypeNames(): Promise<PoolPageTypeName[]> {
    return ApiClient.get<PoolPageTypeName[]>('/reports/maintenance/poolpagetypenames');
  }

  static async updatePoolPageTypeName(request: UpdatePoolPageTypeNameRequest): Promise<void> {
    await ApiClient.put<void>('/reports/maintenance/poolpagetypenames', request);
  }

  static async getAvailablePools(): Promise<PoolInfo[]> {
    const pools = await ApiClient.get<{ PoolId: number; Name: string }[]>('/reference-data/pools');
    return pools.map((p) => ({ poolId: p.PoolId, name: p.Name }));
  }
}
